<ion-content>
  <router-outlet></router-outlet>
</ion-content>
